import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";
import UserPasswordManagement from "@/components/main/user/management/component.vue";
import BSelect from "@/components/singles/BSelect/component.vue";
import BMMenu from "@/components/singles/BMMenu/component.vue";
import BDDM from "@/components/singles/BDDM/component.vue";
import EditableText from "@/components/singles/EditableText/component.vue";
import BModal from "@/components/singles/BModal/component.vue";
import BForm from "@/components/singles/BForm/component.vue";
import _ from "lodash";

export default {
  name: "user-management",
  components: {
    ValidationObserver,
    ValidationProvider,
    UserPasswordManagement,
    BForm,
    BSelect,
    BMMenu,
    BDDM,
    EditableText,
    BModal
  },
  props: [],
  data() {
    return {
      showAddUserModal: false,

      items: [],
      groups: null,
      roles: null,
      filter: "false",
      filter2: "false",
      showAddUser: false,

      groupMenu: {
        selectedItems: [],
        visible: false,
        title: "",
        subtitle: "Groups",
        nameProp: "name",
        idProp: "uid"
      },
      form: {
        valid: false,
        selects: [
          {
            name: "roles",
            label: "Role",
            nameProp: "name",
            title: "Roles",
            selected: null,
            order: "level",
            validation: "required",
            items: []
          }
        ],

        inputs: [
          {
            icon: "fa-user",
            name: "username",
            placeholder: "Username",
            type: "text",
            label: null,
            validation: "required|email",
            value: "",
            focus: true
          },
          {
            icon: "fa-pen",
            name: "name",
            placeholder: "Name",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: ""
          },
          {
            icon: "fa-key",
            label: null,
            name: "password",
            placeholder: "Password",
            type: "password",
            validation: "required|min:8|confirmed:confirmation",
            value: ""
          }
        ]
      },

      changePassword: {
        uid: null,
        name: null,
        showDialog: false
      }
    };
  },
  computed: {
    orderedItems: function() {
      return _.orderBy(this.items, "level");
    }
  },

  created() {
    this.GetItems();
    this.GetRoles();
    this.GetGroups();
  },
  mounted() {},

  methods: {
    async impersonate(item) {
      const username = item.user.username;
      const data = await this.$helpers.PostApi("impersonation-login", {
        username
      });

      this.$ls.set("user", data.user);
      this.$ls.set("role", data.role);

      this.$helpers.GetAuthInfo();

      this.$helpers.ShowStatus(
        "Welcome! <span style='margin-left:10px;' class='icon'><i class='fas fa-lg fa-grin-beam'></i></span>",
        4000
      );
    },

    GroupItemAdd(user, obj) {
      console.log(user, obj);
      this.AddUserToGroup(user, [obj.uid]);
    },

    GroupItemRemove(obj) {
      this.RemoveUserFromGroup(this.groupMenu.fullItem, obj.uid);
    },

    filteredItems: (items, filter) => {
      if (items) {
        return items.filter(item => {
          if (!item.edit) {
            if (item.user.deleted.toString() === filter || filter === "all") {
              return true;
            } else {
              return false;
            }
          }

          return true;
        });
      }
    },

    ShowStatus(message, timeout) {
      this.$helpers.ShowStatus(message, timeout, this.status);
    },

    filterTest(items) {
      var filter = {
        user: {
          name: "!admin"
        }
      };

      var result = this.$helpers.Filter(items, filter);
      return result;
    },

    async Save() {
      this.SaveBefore();

      let exists = this.items.find(
        item =>
          item.user.username.toLowerCase() ===
          this.form.inputs[0].value.toLowerCase()
      );

      if (exists) {
        this.ShowStatus(
          '"' + this.form.inputs[0].value + '" already exists',
          5000
        );

        this.form.inputs[0].value = "";
        this.$store.state.saving = false;
        this.$store.state.loading = false;
      } else {
        var path = "";
        if (this.form.selects[0].selected.level === 1) {
          path = "create/user";
        } else {
          path = "create/customer";
        }

        this.$helpers
          .PostApi(path, {
            username: this.form.inputs[0].value.toLowerCase(),
            name: this.form.inputs[1].value,
            password: this.form.inputs[2].value,
            roleUID: this.form.selects[0].selected.uid
          })
          .then(res => {
            this.showAddUserModal = false;
            this.SaveSuccessful(res);
          })
          .catch(err => {
            this.SaveError(err);
          });
      }
    },

    SaveBefore() {
      this.$store.state.saving = true;
      this.$store.state.loading = true;
    },
    SaveSuccessful(res) {
      var newItem = res[0];
      this.ShowStatus('"' + newItem.user.name + '" was saved', 2000);
      this.$helpers.ClearForm(this.form);
      this.items.push(newItem);
      this.$store.state.saving = false;
      this.$store.state.loading = false;
    },
    SaveError(err) {
      console.log(err);
      this.$store.state.saving = false;
      this.$store.state.loading = false;
      C;
      this.ShowStatus("Ett fel uppstod", 4000);
    },

    async GetItems() {
      var path = "";
      if (this.$ls.get("role").level === 1) {
        path = "get/users";
      } else {
        path = "get/groupUsers";
      }

      this.$helpers
        .PostApi(path, {})
        .then(res => {
          this.items = res;
          this.filterTest(this.items);
        })
        .catch(err => {
          console.log(err);
        });
    },

    async GetRoles() {
      await this.$helpers
        .PostApi("get/roles", {})
        .then(res => {
          this.roles = res[0];
          this.form.selects[0].items = this.roles;
        })
        .catch(err => {
          console.log(err);
        });
    },

    async GetGroups() {
      var path = "";
      if (this.$ls.get("role").level === 1) {
        path = "get/groups";
      } else {
        path = "get/groupGroups";
      }

      await this.$helpers
        .PostApi(path, {})
        .then(res => {
          this.groups = res[0];
        })
        .catch(err => {
          console.log(err);
        });
    },

    Edit(item, index) {
      item.edit = !item.edit;
      this.$forceUpdate();
    },

    DoesGroupExist(groupUID, groups) {
      var groupUIDs = groups.map(x => x.uid);
      var exist = this.$helpers.DoesItemExist(groupUID, groupUIDs);
      return exist;
    },

    async SaveChange(item) {
      this.SaveBefore();

      this.$helpers
        .PostApi("set/user", {
          uid: item.user.uid,
          object: {
            deleted: !item.user.deleted
          }
        })
        .then(res => {
          item.user.deleted = !item.user.deleted;
          this.ShowStatus("Saved", 2000);
          this.$store.state.saving = false;
          this.$store.state.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.$store.state.saving = false;
          this.$store.state.loading = false;
        });
    },

    async ShowChangePasswordDialog(item) {
      this.changePassword.uid = item.user.uid;
      this.changePassword.name = item.user.name;
      this.changePassword.showDialog = true;
    }
  }
};
